import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { PdfData } from '@/models';

// Define a service using a base URL and expected endpoints
export const pdfApi = createApi({
  reducerPath: 'pdfApi',
  baseQuery,
  endpoints: (builder) => ({
    getCampaignSchedulePDF: builder.query<PdfData, string>({
      query: (id) => `/pdf/api/v1/campaign-schedule/${id}`
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLazyGetCampaignSchedulePDFQuery } = pdfApi;
